import AppModal from '@components/AppModal';
import Text from '@components/Text';
import colors from '@constants/colors';
import { ActivityComponentType, useFlow } from '@stackflow/react';

declare module '@stackflow/config' {
    interface Register {
        SinglePurchaseModal: {};
    }
}

const SinglePurchaseModal: ActivityComponentType<'SinglePurchaseModal'> = () => {
    const { pop } = useFlow();
    return (
        <AppModal title='이 메뉴를 바로 주문할까요?'
            deny='취소'
            confirm='주문하기'
            onConfirm={() => {
                pop();
                // router.push('/purchase');
            }} >
            <Text color={colors.gray6} align='center'>
                개별 메뉴를 주문하면 기존에 장바구니에<br/>
                담은 메뉴가 사라집니다.
            </Text>
        </AppModal>
    );
};

export default SinglePurchaseModal;
